module.exports = "/images/vendor/flag-icon-css/flags/1x1/gy.svg?0653b318bc72188902840668e70e269f";